import { render, staticRenderFns } from "./ProjectsList.vue?vue&type=template&id=3ffdc105&scoped=true"
import script from "./ProjectsList.vue?vue&type=script&lang=js"
export * from "./ProjectsList.vue?vue&type=script&lang=js"
import style0 from "./ProjectsList.vue?vue&type=style&index=0&id=3ffdc105&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffdc105",
  null
  
)

export default component.exports